interface VerticalRect {
  top: number;
  bottom: number;
  height: number;
}

export function calculatePopoverLayout(
  container: VerticalRect,
  popover: VerticalRect,
  viewportHeight: number,
  padding = 10,
): { top: number; maxHeight: number } {
  const maxHeight = Math.max(
    0,
    Math.min(420, viewportHeight * 0.7, container.height - padding * 2),
  );
  const renderedHeight = Math.min(popover.height, maxHeight);
  const lowestTop = container.bottom - renderedHeight - padding;

  return {
    top: Math.max(
      container.top + padding,
      Math.min(popover.top, lowestTop),
    ),
    maxHeight,
  };
}
